import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M0 0h20v20H0z" }));
export {
  o as ReactComponent
};
